import React, { Component } from "react";
import SortableTree, {
  addNodeUnderParent,
  getFlatDataFromTree,
  getTreeFromFlatData,
  changeNodeAtPath,
  removeNodeAtPath,
} from "react-sortable-tree";
import * as actionCreators from "../../../modules/actions/index";
import EnterpriseBreadcrumb from "./../../../components/EnterpriseBreadcrumb/EnterpriseBreadcrumb";
import { connect } from "react-redux";
import moment from "moment";
import { Button, Input,Popover,PopoverBody,PopoverHeader } from "reactstrap";
import axios from "../../../axios";
import * as url from "./../../../utils/url";
import { computeOfficeKey, officeHierarchy } from "./../../../utils/constants";
import Loading from "../../../hoc/Loading/Loading";
import filter from "lodash/filter";

class ImportOfficeHierarchy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSaveBtn: false,
      updatedOffices: {},
      nameChanges: [],
      // oldH: officeHierarchy.staticHierarchy,
      // test2: officeHierarchy.staticHierarchy,
      loadVersionHist: true,
      isNameChanged: false,
      isNewNode: [],
      status: false,
      originalVersion: null,
      reference: null,
      addedTopNode: false,
      moveOfficeInfoBtn: false,
      getVersionHistory: false,
      canSave: true,
      newHierarchy: this.props.user.profile.organizationId.staticHierarchy,
      parentOffice: this.props.user.profile.organizationId.staticHierarchy.map(
        (e) => e.officeKey
      ),
      // newHierarchy:[]
      staticFlat: getFlatDataFromTree({
        treeData: this.props.user.profile.organizationId.staticHierarchy,
        getNodeKey: ({ node }) => node.officeKey,
        ignoreCollapsed: false,
      }),
      newOfficeTitle: "",
      hierarchySaved: false,
      searchString: "",
      searchFocusIndex: 0,
      searchFoundCount: null,
      isAddTitle: false,
      isError: false,
      pageNumber: 0,
      versionHistory: [],
      addAsFirstChild: false,
      changeNodeTitle: false,
      chartStatusPopoverOpen: false,
    };
  }

  showOfficeContainer = () => {
    this.setState((prevState) => ({
      isAddTitle: !prevState.isAddTitle,
      newOfficeTitle: "",
      isError: false,
    }));
  };

  toggleChartStatusPopover = () => {
    this.setState({
      chartStatusPopoverOpen: !this.state.chartStatusPopoverOpen,
    });
  };

  tempFunction = () => {
    let oldH = this.props.user.profile.organizationId.staticHierarchy;

    const flat = getFlatDataFromTree({
      treeData: oldH,
      getNodeKey: ({ node }) => node.id,
      ignoreCollapsed: false,
    });

    // console.log('flat--', flat)

    let tempHierarchy = filter(flat, (o) => o != "undefined").map(
      (office, i) => {
        const o = { ...office, ...office.node };
        o.id = computeOfficeKey(
          office.node.title,
          this.props.user.profile.organizationId
        );
        o.node.id = computeOfficeKey(
          office.node.title,
          this.props.user.profile.organizationId
        );
        o.node.officeKey = computeOfficeKey(
          office.node.title,
          this.props.user.profile.organizationId
        );
        o.officeKey = computeOfficeKey(
          office.node.title,
          this.props.user.profile.organizationId
        );
        o.title = office.node.title;
        // o.node.parent = office
        o.subtitle = "";
        // o.node.children = [];
        return o;
      }
    );

    // // console.log(tempHierarchy)

    let officeHierarchy = getTreeFromFlatData({
      flatData: tempHierarchy.map((e) => {
        return {
          ...e,
          officeKey: e.officeKey,
          // id: e.officeKeyz
        };
      }),
      getKey: (node) => node.officeKey,
      getParentKey: (node) => node.parentNode,
      rootKey: null,
    });

    console.log(oldH, "-----with Key---", officeHierarchy);
    // this.props.saveOfficeHierarchy(officeHierarchy);
  };

  componentDidMount() {
    console.log("inside-----");
    // this.tempFunction()
  }

  computeOfficeHash = (str, org) => {
    let result =
      Date.now() +
      [...str].reduce((acc, currVal) => acc.concat(currVal.charCodeAt())) +
      "orgName" +
      org;
    return result;
  };

  addOfficeName = ({ target }) => {
    let { value } = target;
    this.setState({ newOfficeTitle: value});
  };

  addOfficetoHierarchy = () => {
    let { newOfficeTitle, newHierarchy, isNewNode } = this.state;
    // const getNodeKey = ({ treeIndex }) => treeIndex;
    // console.log(getNodeKey)
    let org = this.props.user.profile.organizationId;
    let officeName = newOfficeTitle.replace(/(^\s+|\s+$)/g, "");
    let newOffice = {
      title: officeName.replace(/^\s+|\s+$/g, ""),
      officeKey: `${computeOfficeKey(officeName, org)}`.replace(
        /^\s+|\s+$/g,
        ""
      ),
      children: [],
      expanded: true,
      id: `${computeOfficeKey(officeName, org)}`.replace(/^\s+|\s+$/g, ""),
      dateCreated: { date: Date.now(), iso: new Date().toISOString() },
      activity: { type: "new office", date: Date.now() },
      lastModified: Date.now(),
      subtitle: "",
    };

    // newHierarchy.unshift(newOffice)
    // newHierarchy.splice(0, 0, newOffice)
    //   console.log(newHierarchy)
    //   console.log(newHierarchy[0],newHierarchy[0].expanded)
    // newHierarchy[0].expanded = false
    // newHierarchy.concat(newOffice)
    //   console.log(newHierarchy)

    isNewNode.push(newOffice.lastModified);

    if (officeName.length > 0) {
      this.setState((prevState) => ({
        newHierarchy: newHierarchy.concat(newOffice),
        showSaveBtn: true,
        addedTopNode: true,
        moveOfficeInfoBtn: true,
        isTreeDataChanged: true,
        isError: false,
        newOfficeTitle: "",
        isNewNode,
      }));
    } else {
      this.setState({ isError: true });
    }
  };

  searchCallback = (matches) => {
    let { searchFocusIndex } = this.state;
    this.setState({
      searchFoundCount: matches.length,
      searchFocusIndex:
        matches.length > 0 ? searchFocusIndex % matches.length : 0,
    });
  };

  saveHierarchy = () => {
    let { canSave } = this.state;
    this.setState({ canSave: false });
    if (canSave) {
      let {
        newHierarchy,
        updatedOffices,
        status,
        originalVersion,
        isTreeDataChanged,
        reference,
      } = this.state;
      let {
        staticHierarchy,
        hierarchyVersion,
        createdDate,
        hierarchyStartDate,
      } = this.props.user.profile.organizationId;

      hierarchyVersion = !hierarchyVersion ? 1 : hierarchyVersion;
      let payload = {
        oldHierarchy: staticHierarchy,
        newHierarchy,
        hierarchyVersion,
        startDate: !hierarchyStartDate ? createdDate : hierarchyStartDate,
      };

      if (status) {
        payload.status = true;
        payload.reference = reference;
        payload.originalVersion = originalVersion;
        payload.staticHierarchy = staticHierarchy;
      }

      payload.organizationId = { ...this.props.user.profile.organizationId };

      let that = this;
      let isOfficesUpdated = Object.keys(updatedOffices).length > 0;

      payload.isTreeDataChanged = isTreeDataChanged;

      // console.log(updatedOffices,'---', newHierarchy)

      if (isTreeDataChanged) {
        axios
          .all([axios.post(url.saveOrgChart, payload)])
          .then(
            axios.spread(function(hierarchy, offices) {
              if (hierarchy && hierarchy.data && hierarchy.data.data) {
                hierarchy.data.data.isTreeDataChanged = true;
                that.props.saveNewHierarchy(hierarchy.data.data);
                that.props.manageNewOffices([]);
                // if(isOfficesUpdated){
                //   that.props.saveDisabledOffices([])
                // }

                that.setState({
                  hierarchySaved: true,
                  showSaveBtn: false,
                  moveOfficeInfoBtn: false,
                  status: false,
                  canSave: true,
                  pageNumber: 0,
                  isNewNode: [],
                  versionHistory: [],
                  isNameChanged: false,
                  nameChanges: [],
                  updatedOffices: {},
                  isTreeDataChanged: false,
                });
              } else {
                console.log("-----");
              }
            })
          )
          .catch((error) => {
            console.log(error);
          });
      } else if (!isTreeDataChanged) {
        axios
          .all([
            // axios.post(url.changeOfficeNames, updatedOffices),
            axios.post(url.hierarchyNameChange, newHierarchy),
          ])
          .then(
            axios.spread(function(hierarchy) {
              // console.log('finished with data------')
              that.props.saveNewHierarchy(hierarchy.data.data);
              that.props.manageNewOffices([]);

              // that.props.saveOfficeHierarchy(newHierarchy);
              that.props.saveDisabledOffices([]);

              that.setState({
                showSaveBtn: false,
                moveOfficeInfoBtn: false,
                hierarchySaved: true,
                versionHistory: [],
                isNewNode: [],
                pageNumber: 0,
                isTreeDataChanged: false,
                canSave: true,
                isNameChanged: false,
                isNewNode: [],
                nameChanges: [],
                updatedOffices: {},
              });
            })
          )
          .catch((error) => {
            console.log(error);
          });
      }
    }
  };

  restoreHierarchy = () => {
    const { staticHierarchy } = this.props.user.profile.organizationId;
    // console.log(this.state.newHierarchy, staticHierarchy)
    let { newHierarchy } = this.state;
    newHierarchy = staticHierarchy;
    this.setState({
      newHierarchy,
      showSaveBtn: false,
      moveOfficeInfoBtn: false,
      isNameChanged: false,
      isNewNode: [],
      nameChanges: [],
      status: false,
      pageNumber: 0,
      reference: null,
      isTreeDataChanged: false,
      versionHistory: [],
      hierarchySaved: false,
    });
  };

  closeBtn = () => {
    this.setState({ hierarchySaved: false });
  };

  changeHierarchy = (newHierarchy) => {
    let { isTreeDataChanged, addedTopNode } = this.state;
    if (isTreeDataChanged && addedTopNode) {
      newHierarchy.unshift(newHierarchy.pop());
      this.setState({ addedTopNode: false });
      return newHierarchy;
    } else {
      return newHierarchy;
    }
  };

  closeInfoBtn = () => {
    this.setState({ moveOfficeInfoBtn: false });
  };

  officeNameArray = (node, val) => {
    // console.log(node, val)
    if (node.officeNameArr && node.officeNameArr.length > 0) {
      return [...node.officeNameArr, val];
    } else {
      return [val];
    }
  };

  addNewNodePath = (path, treeIndex) => {
    // console.log(treeIndex, path)
    // [0,1][1]
    if (treeIndex == 0) {
      // return path[1]
      // console.log(path[path.length - 1])
      return path[path.length - 1];
    } else {
      return path[path.length - 1];
    }
  };

  createChildNode = (parent) => {
    console.log("parent---", parent);
    let { isNewNode } = this.state;
    let org = this.props.user.profile.organizationId;
    let pTitle =
      parent.title && parent.title.length > 0
        ? parent.title + " child " + parent.children.length
        : "NEW OFFICE";
    let title = `${pTitle} - ${Date.now()}`;
    let officeKeyTitle = title.replace(/^\s+|\s+$/g, "");
    let obj = {
      title,
      officeKey: `${computeOfficeKey(officeKeyTitle, org)}`.replace(
        /^\s+|\s+$/g,
        ""
      ),
      dateCreated: { date: Date.now(), iso: new Date().toISOString() },
      isNewChild: true,
      activity: { type: "new office", date: Date.now() },
      lastModified: Date.now(),
      id: `${computeOfficeKey(officeKeyTitle, org)}`.replace(/^\s+|\s+$/g, ""),
      children: [],
    };

    console.log("TESTING");

    isNewNode.push(obj.lastModified);
    this.setState({ isNewNode });
    return obj;
  };

  modifyNode = (node) => {
    // console.log('mod_node------', node)
    let { isNewNode, nameChanges, updatedOffices } = this.state;
    let org = this.props.user.profile.organizationId;
    let newName = { type: "new title", date: Date.now() };

    if (
      nameChanges &&
      nameChanges.length > 0 &&
      nameChanges.indexOf(node.officeKey) === -1
    ) {
      nameChanges.push(node.officeKey);
      node.archivedOfficeNames = this.officeNameArray(node, {
        title: node.title,
        date: Date.now(),
        isoDate: new Date().toISOString(),
      });
      if (
        node.activity &&
        node.activity !== undefined &&
        node.activity.length > 0 &&
        Array.isArray(node.activity)
      ) {
        node.activity.unshift(newName);
      } else {
        node.activity = [newName];
      }
    } else if (nameChanges.length === 0) {
      nameChanges.push(node.officeKey);
      node.archivedOfficeNames = this.officeNameArray(node, {
        title: node.title,
        date: Date.now(),
        isoDate: new Date().toISOString(),
      });
      if (
        node.activity &&
        node.activity !== undefined &&
        node.activity.length > 0 &&
        Array.isArray(node.activity)
      ) {
        node.activity.unshift(newName);
      } else {
        node.activity = [newName];
      }
    }

    if (node && node.node && node.node.title) {
      node.node.title = node.newTitle;
    }

    console.log(node.officeKey, node);
    // let today = new Date(Date.now()).getDay()
    // let nodeCreated = new Date(node.dateCreated.date).getDay()

    // node.isNewChild=false

    let obj = {
      ...node,
      officeKey: node.isNewChild
        ? computeOfficeKey(node.newTitle, org).replace(/^\s+|\s+$/g, "")
        : node.officeKey.replace(/^\s+|\s+$/g, ""),
      title: node.newTitle.replace(/^\s+|\s+$/g, ""),
      newTitle: "",
      lastModified: Date.now(),
    };

    console.log(updatedOffices, "---obj-----", obj);

    // after name change, child is no longer new
    obj.isNewChild = false;

    if (!updatedOffices[node.officeKey]) {
      updatedOffices = { ...updatedOffices, [node.officeKey]: { ...obj } };
    } else {
      updatedOffices = {
        ...updatedOffices,
        [node.officeKey]: {
          ...updatedOffices[node.officeKey],
          title: obj.title,
        },
      };
    }

    console.log(updatedOffices);
    isNewNode.push(obj.lastModified);
    this.setState((prevState) => ({ isNewNode, nameChanges, updatedOffices }));
    return obj;
  };

  checkNodeNewTitle = (node) => {
    let { isNewNode, isNameChanged, showSaveBtn } = this.state;
    // console.log(isNewNode,isNameChanged, showSaveBtn, node )
    let isChanged;
    if (
      node.newTitle &&
      typeof node.newTitle !== undefined &&
      node.newTitle.length > 0
    ) {
      isChanged = true;
    }
    // else if (isNewNode.indexOf(node.lastModified)>-1 && node.archivedOfficeNames & node.archivedOfficeNames.length>0 && showSaveBtn && isNameChanged ){
    //   isChanged=true
    // }
    else {
      isChanged = false;
    }
    return isChanged;
  };

  restoreOgChartVersion = (v) => {
    console.log(v);
    this.setState({
      newHierarchy: v.hierarchy,
      status: true,
      isTreeDataChanged: true,
      originalVersion: v.version,
      reference: v._id,
      showSaveBtn: true,
      hierarchySaved: false,
    });
  };

  getVersionHistory = () => {
    // let {organizationId}=this.props.user.profile
    let { pageNumber } = this.state;

    axios.get(url.getOrgCharts(pageNumber)).then(({ data }) => {
      console.log("data---", data.data);
      pageNumber = pageNumber + 1;
      let results = data.data;
      this.setState((prevState) => ({
        versionHistory: prevState.versionHistory.concat(results),
        pageNumber,
        getVersionHistory: true,
        loadVersionHist:
          results.length === 0 || results.length < 10 ? false : true,
        hierarchySaved: false,
      }));
    });
  };

  render() {
    const { staticHierarchy } = this.props.user.profile.organizationId;
    let {
      nameChanges,
      moveOfficeInfoBtn,
      isNameChanged,
      reference,
      pageNumber,
      versionHistory,
      addedTopNode,
      isNewNode,
      newHierarchy,
      showSaveBtn,
      staticFlat,
      isAddTitle,
      isError,
      newOfficeTitle,
      changeNodeTitle,
      hierarchySaved,
      searchString,
      searchFocusIndex,
      searchFoundCount,
      parentOffice,
      canSave,
      getVersionHistory,
      loadVersionHist,
    } = this.state;
    const getNodeKey = ({ treeIndex }) => treeIndex;
    console.log(this.props);

    const { manageNewOffices } = this.props.orgChart;

    let orgChartVersion =
      this.props.user.profile.organizationId &&
      this.props.user.profile.organizationId.hierarchyVersion
        ? this.props.user.profile.organizationId.hierarchyVersion
        : 0;
    // console.log(this.props.user.organizationId, orgChartVersion)
    const newFlat = getFlatDataFromTree({
      treeData: newHierarchy,
      getNodeKey: ({ node }) => node.id,
      ignoreCollapsed: false,
    });
    // console.log(this.props.user.profile.organizationId)
    let orgName = this.props.user.profile.organizationId.name;

    const customSearchMethod = ({ node, searchQuery }) =>
      searchQuery &&
      node.title.toLowerCase().indexOf(searchQuery.toLowerCase()) > -1;

    const selectPrevMatch = () =>
      this.setState({
        searchFocusIndex:
          searchFocusIndex !== null
            ? (searchFoundCount + searchFocusIndex - 1) % searchFoundCount
            : searchFoundCount - 1,
      });

    const selectNextMatch = () =>
      this.setState({
        searchFocusIndex:
          searchFocusIndex !== null
            ? (searchFocusIndex + 1) % searchFoundCount
            : 0,
      });

    // console.log(versionHistory)

    return (
      <div className="sideBarMenuItems" style={{ padding: "10px" }}>
        <EnterpriseBreadcrumb
          top={""}
          linkText="Enterprise Management"
          link="/home/enterprise-info"
          activeText="Import New Office Hierarchy"
          {...this.props}
        />
        <div className="mt30">
          <div className="title-text">Import New Office Hierarchy</div>
        </div>
        <hr />
        <div className="mt40 mb10 org-chart-description-text">
          <p>
            You can see your current office hierarchy below. The current org
            chart version is {orgChartVersion}.
          </p>
          <p>
            {" "}
            To change it, click on the boxes below and move them around as
            needed by hovering your cursor over the left end (the blue area) of
            the desired office. To see or revert back to previous organizational
            charts, please{" "}
            <span
              className="versionHistoryBtn"
              onClick={() => this.getVersionHistory()}
            >
              click here
            </span>
            .
          </p>
          <p>
            <b>Note*</b> if you have any charts that you would like to{" "}
            <span className="versionHistoryBtn" id="chart-status-popover-2" onClick={this.toggleChartStatusPopover}>
              lock
            </span>
            , please do so before changing your organizational hierarchy.
          </p>
          <Popover
            placement="bottom"
            isOpen={this.state.chartStatusPopoverOpen}
            target="chart-status-popover-2"
            toggle={this.toggleChartStatusPopover}
          >
            <PopoverHeader className="popover-header-tooltip">
              Chart Status
            </PopoverHeader>
            <PopoverBody className="popover-body-tooltip">
              <span className="fw600">Active</span> means this chart can be
              updated as new data is uploaded to the system and/or as hierarchy
              changes are made in your organization. <br />
              <br /> <span className="fw600">Locked</span> means this chart’s
              data will no longer updated by new data or hierarchy changes.
            </PopoverBody>
          </Popover>
        </div>

        {versionHistory.length > 0 ? (
          <div className="orgChatListContainer">
            {versionHistory.map((e) => {
              return (
                <div
                  className={
                    e._id === reference
                      ? "orgChartItem selected"
                      : "orgChartItem"
                  }
                  key={e._id + e.startDate}
                >
                  <div className="orgChartListVersion">
                    Organizational Chart Version: {e.version}
                  </div>

                  <div className="orgChartListDate">
                    {" "}
                    <span style={{ display: "block" }}>
                      Start Date:{" "}
                      {moment(e.startDate).format("MM/DD/YYYY, h:mm:ss a")}
                    </span>
                    <span style={{ display: "block" }}>
                      End Date:{" "}
                      {moment(e.endDate).format("MM/DD/YYYY, h:mm:ss a")}
                    </span>
                  </div>
                  {/* <span>{e._id}</span> */}
                  <span
                    className="versionHistoryBtn"
                    onClick={() => this.restoreOgChartVersion(e)}
                  >
                    {" "}
                    Restore this version{" "}
                  </span>
                </div>
              );
            })}
            {loadVersionHist ? (
              <span
                onClick={() => this.getVersionHistory()}
                className="versionHistoryBtn"
              >
                Load More
              </span>
            ) : (
              <span className="noMoreVersionHistoryBtn">
                {" "}
                No Other hierarchy to Load
              </span>
            )}
          </div>
        ) : getVersionHistory ? (
          <div className="orgChartNoResults">
            No previous hierarchy versions
          </div>
        ) : null
        // getVersionHistory
        }

        <div
          className="modifyHierarchyContainer"
          style={{
            marginBottom: manageNewOffices.length > 0 ? "20px" : "60px",
          }}
        >
          {/* <Button onClick={() => this.tempFunction()} color="primary"  className="addOfficeButton">
             <span> Run</span>
           </Button> */}

          {isAddTitle !== true ? (
            <Button
              onClick={() => this.showOfficeContainer()}
              color="primary"
              className="addOfficeButton"
            >
              <span> Create Office </span>
            </Button>
          ) : (
            <div>
              <div>
                {" "}
                Add <span className="newOfficeName">{newOfficeTitle}</span> to
                Org chart
                <Button
                  onClick={() => this.addOfficetoHierarchy()}
                  color="primary"
                  className="addOfficeButton"
                >
                  {" "}
                  yes{" "}
                </Button>
                or{" "}
                <Button
                  style={{ color: "black" }}
                  onClick={() => this.showOfficeContainer()}
                >
                  {" "}
                  close{" "}
                </Button>
              </div>

              <div>
                <div className="rst__row">
                  <div
                    className="rst__moveHandle"
                    style={{ height: "auto" }}
                  ></div>
                  <div
                    className="rst__rowContents"
                    style={{
                      height: "auto",
                      minWidth: "270px",
                      maxWidth: "25%",
                    }}
                  >
                    <div className="rst__rowLabel">
                      <span className="rst__rowTitle">
                        <Input
                          value={newOfficeTitle}
                          className="newOfficeNameInput"
                          placeholder="Office name"
                          onChange={this.addOfficeName}
                        />
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {manageNewOffices && manageNewOffices.length > 0 ? (
          <div className="alert-msg-bg">
            <i className="close-icon">close</i>
            <div className="d-flex custom-message-box">
              <i className="material-icons alert-icon-bg">remove_circle</i>
              <span className="ml10 alert-msg-text">
                <span className="newOfficesFoundTxt">
                  The following {manageNewOffices.length} Office(s) names were
                  found in your recent upload but not found in your hierarchy.
                  Please make the necessary changes and then re-upload your
                  file.
                </span>

                {manageNewOffices.map((e, idx) => {
                  return (
                    <p className="newOfficesFoundContent" key={idx}>
                      {" "}
                      {e.label}{" "}
                    </p>
                  );
                })}
              </span>
            </div>
          </div>
        ) : null}

        {isError ? (
          <p style={{ color: "red" }}>
            Please make sure the new Office name is typed correctly and does not
            already exist.
          </p>
        ) : null}

        <input
          id="find-box"
          type="text"
          placeholder="Search..."
          className="mb40"
          style={{ fontSize: "1rem", marginBottom: "20px" }}
          value={searchString}
          onChange={(event) =>
            this.setState({ searchString: event.target.value })
          }
        />
        {
          // need Patch fix: https://github.com/frontend-collective/react-sortable-tree/issues/821
          // https://github.com/frontend-collective/react-sortable-tree/issues/821#issuecomment-766860082
          /* <button
            type="button"
            disabled={!searchFoundCount}
            onClick={selectPrevMatch}
          >
            &lt;
          </button>

          <button
            type="submit"
            disabled={!searchFoundCount}
            onClick={selectNextMatch}
          >
            &gt;
          </button> */
        }
        <span>
          &nbsp;
          {/* {searchFoundCount > 0 ? searchFocusIndex + 1 : 0}
            &nbsp;/&nbsp;
            {searchFoundCount || 0} */}
          {searchFoundCount > 0
            ? `Found ${searchFoundCount} ${
                searchFoundCount == 1 ? "result" : "results"
              }`
            : null}
        </span>

        {hierarchySaved ? (
          <div className="hierarchyChangeSuccess">
            Hierarchy has been successfully changed.
            <span className="closeBtn" onClick={() => this.closeBtn()}>
              X
            </span>
          </div>
        ) : // staticFlat!==newFlat?
        showSaveBtn ? (
          <div className="hierarchyChangeBtnContainer">
            <Button
              color="primary"
              className={!canSave ? "disabled" : ""}
              onClick={() => this.saveHierarchy()}
            >
              {" "}
              Save Changes ?{" "}
            </Button>
            <p> or </p>
            <Button
              className="backgroundGrey"
              onClick={() => this.restoreHierarchy()}
            >
              {" "}
              Undo all{" "}
            </Button>
          </div>
        ) : null}

        {moveOfficeInfoBtn && newHierarchy && newHierarchy[0] ? (
          <div className="newTopOfficeContainer">
            <div className="newTopOffice">
              You can move your newly created Office,{" "}
              <span className="newOfficeTitle">{newHierarchy[0].title}</span>,
              anywhere within your Org chart below.
            </div>
            <div
              className="closeHierarchyInfoBtn"
              onClick={() => this.closeInfoBtn()}
            >
              x
            </div>
          </div>
        ) : null}
        {/* testing */}

        <SortableTree
          treeData={this.changeHierarchy(newHierarchy)}
          onChange={(newHierarchy) =>
            this.setState({
              newHierarchy: this.changeHierarchy(newHierarchy),
              hierarchySaved: false,
            })
          }
          generateNodeProps={({
            node,
            isSearchFocus,
            isSearchMatch,
            lowerSiblingCounts,
            parentNode,
            path,
            treeIndex,
          }) => ({
            // onChange: (event) => console.log(
            //   event.target.parentNode.parentNode.parentNode.parentNode.parentNode,
            //   event.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode,
            //   event.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode),
            className: this.checkNodeNewTitle(node)
              ? "minHeight"
              : node && isNewNode.indexOf(node.lastModified) > -1
              ? "officeTempModified"
              : "",
            title: (
              <div>
                <span>
                  {this.checkNodeNewTitle(node) ? node.newTitle : node.title}
                </span>
                {/* {node.oldTitle?
                <div className="originalOfficeName"> Original Office name: {node.oldTitle} </div>
                :
                null
                } */}
                {this.checkNodeNewTitle(node) ? (
                  <div className="originalOfficeName">
                    {" "}
                    Previous Office name: {node.title}{" "}
                  </div>
                ) : null}
                {isNewNode.indexOf(node.lastModified) > -1 &&
                showSaveBtn &&
                nameChanges.length > 0 &&
                nameChanges.indexOf(node.officeKey) > -1 &&
                Array.isArray(node.archivedOfficeNames) &&
                node.archivedOfficeNames.length > 0 ? (
                  <div className="originalOfficeName">
                    Initial Office name:{node.archivedOfficeNames[0].title}
                  </div>
                ) : null}

                {/* { isNewNode.indexOf(node.lastModified)>-1 && showSaveBtn && isNameChanged  && Array.isArray(node.archivedOfficeNames) && node.archivedOfficeNames.length>0?
                    <div className="originalOfficeName">
                      Original office name:{node.archivedOfficeNames[0].title}
                    </div>
                    :
                    null} */}

                <div></div>

                <div style={{ margin: "10px 0px" }}>
                  <input
                    style={{ fontSize: "1.1rem" }}
                    value={node.newTitle ? node.newTitle : ""}
                    placeholder={"change current office name"}
                    onChange={(event) => {
                      let name = event.target.value;
                      // .replace(/(^\s+|\s+$)/g, '')

                      this.setState((state) => ({
                        newHierarchy: changeNodeAtPath({
                          treeData: state.newHierarchy,
                          path,
                          getNodeKey,
                          newNode: {
                            ...node,
                            officeKey: node.officeKey.replace(/^\s+|\s+$/g, ""),
                            newTitle: name.replace(/^\s/g, ""),
                            // oldTitle: oldTitle,
                          },
                        }),
                      }));
                    }}
                  />

                  {node.newTitle && typeof node.newTitle !== "undefined" ? (
                    <Button
                      outline
                      color="success"
                      className="keepNewName"
                      style={{ marginBottom: "4px" }}
                      onClick={() =>
                        this.setState((state) => ({
                          newHierarchy: changeNodeAtPath({
                            treeData: state.newHierarchy,
                            path,
                            getNodeKey,
                            newNode: this.modifyNode(node),
                          }),
                          showSaveBtn: true,
                          isNameChanged: true,
                        }))
                      }
                    >
                      Save ?
                    </Button>
                  ) : null}
                </div>

                <div></div>
              </div>
            ),
            // subtitle: (

            // ),

            buttons: [
              <Button
                outline
                color="primary"
                onClick={() =>
                  this.setState((state) => ({
                    newHierarchy: addNodeUnderParent({
                      treeData: state.newHierarchy,
                      parentKey: this.addNewNodePath(path, treeIndex),
                      expandParent: true,
                      getNodeKey,
                      newNode: this.createChildNode(node),
                      // addAsFirstChild: !state.addAsFirstChild,
                    }).treeData,
                    showSaveBtn: true,
                    isTreeDataChanged: true,
                    // isNewNode: state.isNewNode.push()
                  }))
                }
              >
                Add Office Below
              </Button>,
              <Button
                outline
                className={
                  // parentOffice === node.officeKey?
                  false ? "hideRemoveNodeButton" : ""
                }
                color="danger"
                onClick={() =>
                  false
                    ? null
                    : this.setState((state) => ({
                        newHierarchy: removeNodeAtPath({
                          treeData: state.newHierarchy,
                          path,
                          getNodeKey,
                        }),
                        showSaveBtn: true,
                        isTreeDataChanged: true,
                      }))
                }
              >
                Remove
              </Button>,
            ],
          })}
          canDrag={({ node }) => !node.dragDisabled}
          onMoveNode={(node) => {
            // console.log('node---', node)
            this.setState({
              showSaveBtn: true,
              isTreeDataChanged: true,
              moveOfficeInfoBtn: false,
            });
          }}
          isVirtualized={false}
          searchMethod={customSearchMethod}
          searchQuery={searchString}
          searchFocusOffset={searchFocusIndex}
          // searchFinishCallback={(matches)=> this.searchCallback(matches)}
          searchFinishCallback={(matches) =>
            this.setState({
              searchFoundCount: matches.length,
              searchFocusIndex:
                matches.length > 0 ? searchFocusIndex % matches.length : 0,
            })
          }
        />

        {/* <label htmlFor="addAsFirstChild">
          Add new nodes at start
          <input
            name="addAsFirstChild"
            type="checkbox"
            checked={this.state.addAsFirstChild}
            onChange={() =>
              this.setState(state => ({
                addAsFirstChild: !state.addAsFirstChild,
              }))
            }
          />
        </label> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    orgChart: state.orgChart,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateProfileInfoSuccess: (d) =>
      dispatch(actionCreators.updateProfileInfoSuccess(d)),
    saveOfficeHierarchy: (c) => dispatch(actionCreators.saveOfficeHierarchy(c)),
    manageNewOffices: (newOfficesFound) =>
      dispatch(actionCreators.manageNewOffices(newOfficesFound)),
    saveNewHierarchy: (c) => dispatch(actionCreators.saveNewHierarchy(c)),
    orgHierarchyChange: (c) => dispatch(actionCreators.orgHierarchyChange(c)),
    saveDisabledOffices: (disabledOffices) =>
      dispatch(actionCreators.saveDisabledOffices(disabledOffices)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(ImportOfficeHierarchy, axios));
